import { ListenerApiLight, _select, _take } from '../../listenerMiddleware';
import * as appActions from './actions';
import { getUsers } from './selectors';

export async function obtainUsers(lapi: ListenerApiLight) {
  let users = _select(lapi, getUsers);
  while (users === null) {
    await _take(lapi, appActions.usersPreloaded);
    lapi.signal.throwIfAborted();
    users = _select(lapi, getUsers);
  }
  return users;
}
